import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { TextDataResponse } from 'src/app/common/model/TextDataResponse';

@Injectable({
  providedIn: 'root'
})

export class O2PortalAsuSmrReportService {

  constructor(protected http: HttpClient) {

  }

  baseurl = environment.apiBaseUrl + 'O2PortalGlobalASUAwards';

  getAsuManufacturerReportData() {
    return this.http.get<any[]>(this.baseurl + '/getasuhycodata');
  }

  getAwardYears(): string[] {
    var awardYears: string[] = [];
    var startingYear = 1970;
    var currentYear = (new Date()).getFullYear();
    for (let i = startingYear; i <= (currentYear); i++) {
      awardYears.push(i.toString());
    }
    return awardYears;
  }

  getGlobalASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetGlobalASUAndHYCOAllBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getGlobalASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetGlobalASUAndHYCOSOEBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getGlobalASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetGlobalASUAndHYCOSOGBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getChinaASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetChinaASUAndHYCOAllBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getChinaASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetChinaASUAndHYCOSOEBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getChinaASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetChinaASUAndHYCOSOGBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getROWASUAndHYCOAllBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetROWASUAndHYCOAllBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getROWASUAndHYCOSOEBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetROWASUAndHYCOSOEBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getRowASUAndHYCOSOGBusinessModel(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<any[]>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetRowASUAndHYCOSOGBusinessModel', asuAndHYCOInvestmentFilters);
  }

  getASUAndHYCOInvestmentDetailsReportData(asuAndHYCOInvestmentFilters: any) {
    return this.http.post<TextDataResponse>(environment.apiBaseUrl + 'ASUAndHYCOInvestmentReport/GetASUAndHYCOInvestmentDetailsReportData', asuAndHYCOInvestmentFilters);
  }
}